import {IOfferItem, IOfferWithRewards} from 'types/offers';
import api from '../services/axios';
import {API_ROUTES} from '../constants';

export const getOffers = async (
  params: { platform?: string[]; include_rewards?: boolean; gaid?: string } = {}
): Promise<IOfferItem[]> => {
  // Build query params and remove gaid and set it separately (it will be sent in header for security reasons)
  const gaid = params.gaid;
  const queryParams = { ...params };
  delete queryParams.gaid;

  const response = await api.get(API_ROUTES.OFFERS.LIST, {
    params: queryParams,
    headers: gaid ? { 'X-Ad-Id': gaid } : {}
  });

  // Sort offers by offer_sequence
  const offers: IOfferItem[] = response?.data?.offers || [];
  const sortedOffers = [...offers].sort(
    (a, b) => Number(a.offer_sequence) - Number(b.offer_sequence)
  );
  return sortedOffers;
};

export const getOffer = async (
  offerId: string,
  params?: {include_rewards?: boolean; include_offer_details?: boolean}
): Promise<IOfferWithRewards> => {
  //request to server
  const response = await api.get(`${API_ROUTES.OFFERS.OFFER}/${offerId}`, {params});
  return response?.data?.offer;
};

export const getQRcode = async (offerId: string| number): Promise<string> => {
  const response = await api.post(API_ROUTES.QR_CODE, {offer_id: offerId});
  return response?.data?.qr_code_url;
}
